import { useEffect } from 'react' //injected via WebpackDefinePlugin
const { NODE_ENV, REACT_APP_PERFORMANCE_TRACKER, REACT_APP_INLINE_ALL_ASSETS, REACT_APP_ENTRY_NAME, REACT_APP_CODE_SPLIT } = process.env;

//if assets are inlined, then I'm really only interested in the single bundle
//if they aren't inlined, then I want to look at all of the resources from localhost, imgs, css etc
const inlinedAssets = REACT_APP_INLINE_ALL_ASSETS === 'true'
const split = REACT_APP_CODE_SPLIT === 'true'

//base object detailing what configuration I'm collecting stats on
let base = {
    name: 'appLanding',
    dev: NODE_ENV === 'development',
    split,
    inlinedAssets
}

export default function usePerformance(setStats) {
    useEffect(() => {
        // logNavigationPerformance(); 
        setTimeout(trackPerformance, 2000)
    }, [])
}

function trackPerformance() {
    //waiting for 1 second to allow time for all the BG img requests to run when assets are NOT inlined, paints to get executed, etc
    //using resource performance api
    let resources = performance.getEntriesByType("resource");
    let paintStart = performance.getEntriesByType("paint").find(el => el.name === "first-contentful-paint")?.startTime;
    if (!paintStart) {
        //was still getting some errors where paintStart startTime wasn't defined when hook was running
        // decided to just loop until it was defined before submitting stats
        setTimeout(trackPerformance, 1500)
        return; 
    }
    // console.log(resources)

    // only interested in scripts from HOST
    let pattern = new RegExp(REACT_APP_PERFORMANCE_TRACKER + (inlinedAssets ? `js/${REACT_APP_ENTRY_NAME}` : ''))
    let stats = { ...base }
    if (inlinedAssets) {
        let bundle
        for (let x = 0; x < resources.length; x++) {
            if (pattern.test(resources[x].name)) {
                bundle = resources[x];
                break;
            }
        }
        stats.averages = {
            resourceDuration: bundle.duration,
            transferSize: bundle.transferSize,
            paintStart
        }
    }
    else {
        let firstStart, lastFinish = 0, totalTransferSize = 0;
        for (let x = 0; x < resources.length; x++) {
            if (pattern.test(resources[x].name)) {
                let { startTime, responseEnd, transferSize } = resources[x]
                if (!firstStart || (startTime < firstStart)) firstStart = startTime
                if (responseEnd > lastFinish) lastFinish = responseEnd
                totalTransferSize += transferSize //simple sum of all resources
            }
        }
        if (totalTransferSize === 0) return; //resource wasn't loaded, may have been only a hot-update during development or something
        stats.averages = {
            resourceDuration: lastFinish - firstStart,
            transferSize: totalTransferSize,
            paintStart
        }
    }
    console.log(stats)
    //submit just returns the new averages
    //old version where instead of proxying requests through UI server, just sent request directly to API server
    // fetch(`${REACT_APP_UI_TO_API}performance/submit`, {
    fetch(`/api/performance/submit`, {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        body: JSON.stringify(stats)
    })
        .then(r => r.json())
        .then(r => console.log(r))
}

function logNavigationPerformance() {
    //not really relevant for react, as, EG, loadEnd event fires before any of the DOM has been updated by react
    //left in mostly for demonstration purposes
    let marks = []
    for (let prop in window.performance.timing) {
        if (prop === 'toJSON') continue;
        let mark = {
            type: prop,
            timestamp: window.performance.timing[prop]
        };
        marks.push(mark)
    }
    marks.sort((a, b) => a.timestamp - b.timestamp)
    console.log(marks)
}

function queryAverages() {
    //EXAMPLE OF USING OTHER API ENDPOINT /api/performance/averages to query for current metrics by dev, split, and bundle name
    let queryString = new URLSearchParams();
    queryString.append('name', base.name)
    queryString.append('dev', base.dev)
    queryString.append('split', base.split)
    fetch(`api/performance/averages/?${queryString.toString()}`)
        .then(r => r.json())
        .then(r => console.log(r))
}